export default "__VITE_ASSET__8BftHp7w__"